export const EMAIL_LESSONS_AR = [
  {
    id: 'email-1',
    numero: 1,
    titre: "كتابة بريد إلكتروني واضح",
    sousTitre: "الرسالة التي تُجاب",
    contexte: "تريد مراسلة CAF أو CPAM أو إدارة. كيف تكتب بريداً واضحاً يحصل على رد سريع؟",
    explication: [
      "**الموضوع (Objet)**: جملة واضحة ومختصرة تشرح طلبك + رقم ملفك. مثال: 'طلب شهادة CAF — الرقم 123456'.",
      "**الهيكل**: مقدمة قصيرة (من أنت، لماذا تكتب) + طلبك بوضوح + وثائقك مرفقة + تحياتكم.",
      "**كن محدداً**: بدلاً من 'لدي مشكلة'، اكتب 'لم أستلم دفعة ديسمبر رقم 123456'.",
      "**الطول المناسب**: 5-10 جمل كافية. الرسائل الطويلة جداً تُقرأ أقل. كن مختصراً ومحترماً.",
      "**دائماً أضف**: رقم ملفك، رقم الضمان الاجتماعي أو رقم ضريبتك، اسمك الكامل وتاريخ ميلادك.",
    ],
    question: "ما أهم ما يجب ذكره في موضوع (Objet) البريد الإلكتروني للإدارة؟",
    options: [
      { id: 'a', text: "طبيعة الطلب + رقم الملف", correct: true },
      { id: 'b', text: "اسمك الكامل فقط", correct: false },
      { id: 'c', text: "تاريخ اليوم", correct: false },
    ],
    explication_reponse: "الموضوع الواضح يساعد الموظف على فهم طلبك فوراً وتوجيهه للشخص المناسب. رقم الملف ضروري لإيجاد ملفك بسرعة.",
  },
  {
    id: 'email-2',
    numero: 2,
    titre: "إرفاق ملف",
    sousTitre: "بدون خطأ",
    contexte: "تريد إرسال وثائق مع بريدك الإلكتروني. خطوة بخطوة.",
    explication: [
      "**أيقونة المشبك 📎**: موجودة في كل برنامج بريد إلكتروني. انقر عليها للبحث عن الملف في جهازك.",
      "**التأكد من الإرفاق**: بعد الإرفاق، اسم الملف يظهر أسفل البريد. لا ترسل قبل التأكد من ظهوره.",
      "**الحجم الأقصى**: 5 إلى 10 ميغابايت عادةً. للصور الكبيرة، اضغطها أو أرسلها عبر WeTransfer مجاناً.",
      "**التنسيقات المقبولة**: PDF مفضّل للوثائق الرسمية. الصور JPG مقبولة لكن PDF أكثر احترافية.",
      "**تسمية الملف**: أعطِ كل ملف اسماً واضحاً قبل الإرسال — 'RIB_NomPrenom.pdf' أفضل من 'photo123.jpg'.",
    ],
    question: "كيف تتأكد أن الملف مرفق فعلاً قبل الإرسال؟",
    options: [
      { id: 'a', text: "اسم الملف يظهر أسفل البريد", correct: true },
      { id: 'b', text: "أيقونة المشبك تتغير لوناً", correct: false },
      { id: 'c', text: "لا يمكن التأكد قبل الإرسال", correct: false },
    ],
    explication_reponse: "بعد الإرفاق الناجح، اسم الملف وحجمه يظهران في البريد. إذا لم يظهرا، لم يُرفق الملف — حاول مجدداً.",
  },
  {
    id: 'email-3',
    numero: 3,
    titre: "التعرف على البريد الاحتيالي",
    sousTitre: "لا تنقر قبل أن تتحقق",
    contexte: "بريد يدّعي أنه من الضرائب أو الـ CAF يطلب بياناتك. كيف تعرف إذا كان حقيقياً؟",
    explication: [
      "**تحقق من عنوان البريد**: بريد حقيقي من CAF ينتهي بـ @caf.fr أو @service-public.fr — وليس @gmail.com أو @hotmail.com.",
      "**علامات الاحتيال**: إلحاح مبالغ فيه ('استجب خلال 24 ساعة')، طلب كلمة المرور أو معلومات بطاقة البنك، رابط مشبوه.",
      "**لا تنقر على الروابط مباشرة**: انسخ عنوان الموقع واكتبه يدوياً في متصفحك — أو اذهب مباشرة إلى الموقع الرسمي.",
      "**الإدارات الفرنسية لا تطلب** كلمات المرور ولا أرقام بطاقة البنك عبر البريد الإلكتروني أبداً.",
      "**في حالة شك**: اتصل مباشرة بالجهة المعنية برقمها الرسمي للتحقق. لا ترد على البريد المشبوه.",
    ],
    question: "بريد يدّعي أنه من CAF يطلب رقم بطاقة بنكك. ماذا تفعل؟",
    options: [
      { id: 'a', text: "لا ترد وأبلّغ عنه على signal-spam.fr", correct: true },
      { id: 'b', text: "أعطِ المعلومات إذا كان شعار CAF موجوداً", correct: false },
      { id: 'c', text: "اتصل بالرقم المذكور في البريد", correct: false },
    ],
    explication_reponse: "CAF لا تطلب أبداً معلومات بنكية عبر البريد. إنه احتيال. بلّغ عنه على signal-spam.fr ولا ترد. إذا شككت في حسابك، تصل مباشرة بـ CAF على 3230.",
  },
  {
    id: 'email-4',
    numero: 4,
    titre: "تنظيم صندوق بريدك",
    sousTitre: "لا تضيع وثيقة مهمة",
    contexte: "صندوق بريدك ممتلئ والوثائق المهمة تضيع. بعض الحلول البسيطة لتنظيمه.",
    explication: [
      "**المجلدات**: أنشئ مجلدات بأسماء مثل 'CAF'، 'Impôts'، 'Santé'، 'Logement'. انقل كل بريد مهم لمجلده.",
      "**النجمة ⭐**: في Gmail وOutlook، نجّم الرسائل المهمة للعثور عليها بسرعة لاحقاً.",
      "**إلغاء الاشتراك**: انقر على 'إلغاء الاشتراك' (Se désabonner) في النشرات الإخبارية غير المرغوبة.",
      "**البحث**: استخدم خاصية البحث مع اسم الجهة (مثلاً 'CAF') بدلاً من التمرير للبحث يدوياً.",
      "**الأرشفة**: الرسائل المعالجة التي لا تحتاجها فوراً — أرشفها بدلاً من حذفها. ستبقى متاحة للبحث.",
    ],
    question: "كيف تجد بسرعة بريد قديم من CAF في صندوقك؟",
    options: [
      { id: 'a', text: "استخدام خاصية البحث بكلمة 'CAF'", correct: true },
      { id: 'b', text: "التمرير يدوياً عبر كل الرسائل", correct: false },
      { id: 'c', text: "لا يمكن إيجاده إذا كان قديماً", correct: false },
    ],
    explication_reponse: "خاصية البحث في البريد الإلكتروني قوية جداً — تجد أي بريد في ثوانٍ بكلمة بحث واحدة. استخدم اسم الجهة أو موضوع البريد.",
  },
];
